import { Badge } from '@/components/ui/badge'
import { Skeleton } from '@/components/ui/skeleton'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { useMcpAuditLog } from '../../../../../models/agentAdmin'

function formatTime(timestamp: string): string {
  return new Date(timestamp).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  })
}

export function TracesTab() {
  const { data: entries, isLoading } = useMcpAuditLog()

  if (isLoading)
    return (
      <div className="space-y-2">
        <Skeleton className="h-10 w-full" />
        {Array.from({ length: 5 }, (_, i) => (
          <Skeleton key={i} className="h-8 w-full" />
        ))}
      </div>
    )

  if (!entries?.length) {
    return <p className="text-gray-500">No tool calls recorded. This resets on deploy.</p>
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Time</TableHead>
          <TableHead>Tool</TableHead>
          <TableHead>User</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-right">Latency</TableHead>
          <TableHead>Error</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {entries.map((entry, i) => (
          <TableRow key={`${entry.timestamp}-${i}`}>
            <TableCell className="text-xs">{formatTime(entry.timestamp)}</TableCell>
            <TableCell className="font-mono text-sm">{entry.toolName}</TableCell>
            <TableCell className="text-sm">{entry.userEmail || '-'}</TableCell>
            <TableCell>
              <Badge variant={entry.success ? 'default' : 'destructive'}>
                {entry.success ? 'OK' : 'Failed'}
              </Badge>
            </TableCell>
            <TableCell className="text-right text-sm">{entry.latencyMs}ms</TableCell>
            <TableCell className="max-w-xs truncate text-sm text-red-500">{entry.error || '-'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
